import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Slider } from "@/components/ui/slider";
import { FILTER } from "@/constants/testIds";

const EMOTIONS = [
  { key: "melancholy", id: FILTER.melancholy, dot: "bg-blue-400" },
  { key: "rage", id: FILTER.rage, dot: "bg-rose-400" },
  { key: "serenity", id: FILTER.serenity, dot: "bg-emerald-400" },
  { key: "anxiety", id: FILTER.anxiety, dot: "bg-orange-400" },
  { key: "euphoria", id: FILTER.euphoria, dot: "bg-purple-400" },
];

export default function EmotionFilter({ filters, setFilters, onReset }) {
  const toggle = (k) => setFilters((f) => ({ ...f, emotion: f.emotion === k ? null : k }));
  return (
    <div data-testid={FILTER.bar} className="telesis-panel rounded p-4 md:p-5 space-y-4">
      <div>
        <p className="telesis-eyebrow mb-2">Hue filter</p>
        <div className="flex flex-wrap gap-2">
          {EMOTIONS.map((e) => (
            <button
              key={e.key}
              data-testid={e.id}
              onClick={() => toggle(e.key)}
              className={`telesis-pill flex items-center gap-2 ${
                filters.emotion === e.key ? "bg-yellow-400 text-black border-yellow-400" : "bg-black/30 text-slate-300"
              }`}
            >
              <span className={`w-2 h-2 rounded-full ${e.dot}`} />
              {e.key}
            </button>
          ))}
        </div>
      </div>
      <div>
        <div className="flex justify-between text-[10px] font-mono uppercase tracking-widest text-slate-400 mb-1">
          <span>Min intensity (fonçé)</span>
          <span>{filters.minIntensity}%</span>
        </div>
        <Slider
          data-testid={FILTER.intensity}
          value={[filters.minIntensity]}
          min={0}
          max={100}
          step={5}
          onValueChange={(v) => setFilters((f) => ({ ...f, minIntensity: v[0] }))}
        />
      </div>
      <div>
        <div className="flex justify-between text-[10px] font-mono uppercase tracking-widest text-slate-400 mb-1">
          <span>Min consistency (resolution)</span>
          <span>{filters.minConsistency}%</span>
        </div>
        <Slider
          data-testid={FILTER.consistency}
          value={[filters.minConsistency]}
          min={0}
          max={100}
          step={5}
          onValueChange={(v) => setFilters((f) => ({ ...f, minConsistency: v[0] }))}
        />
      </div>
      <div className="flex gap-2 items-center">
        <Input
          data-testid={FILTER.search}
          placeholder="Search mentation…"
          value={filters.q}
          onChange={(e) => setFilters((f) => ({ ...f, q: e.target.value }))}
          className="bg-[#12141c] border-[#222634] text-slate-100 flex-1"
        />
        <Button
          data-testid={FILTER.reset}
          onClick={onReset}
          variant="ghost"
          className="text-slate-400 hover:text-yellow-400"
        >
          Reset
        </Button>
      </div>
    </div>
  );
}
